import React, {useEffect, useState} from 'react';
import {LOCAL_STORAGE_USER_LOGIN_INFO, ResponseCode} from "@app/constants/Common";
import * as CandidateService from "@app/services/CandidateService";
import {alertMessage} from "@app/constants/Messages";
import AllUserInputField from "@pages/candidate/commonview/AllUserInputField";
import {showSuccessMessageSaveData} from "@pages/candidate/Common";
import {toast} from "react-toastify";
import InputMoreModal from "@pages/candidate/commonview/InputMoreModal";


const InitCustomNotes = {
    notes: {},
    summaries: [],
}

const CandidateCustomNotes = (props) => {
    const [customNote, setCustomNote] = useState({
        notes: {},
        summaries: [],
    });
    const [isEdit, setEdit] = useState(false);
    const [isLoading, setIsLoading] = useState({});
    const [userLoginInfo, setUserLoginInfo] = useState({});
    const [showInputMoreModal, setShowInputMoreModal] = useState(false);
    const [selectedRecord, setSelectedRecord] = useState({});

    useEffect(() => {
        if (!userLoginInfo.id && localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)) {
            setUserLoginInfo(JSON.parse(localStorage.getItem(LOCAL_STORAGE_USER_LOGIN_INFO)))
        }
    }, [])
    const {candidateId, allInputInfo} = props

    const fetchCustomNotes = async (canId) => {
        setIsLoading(true)
        const res = await CandidateService.getCustomNotesDetail(canId)
        setIsLoading(false)
        if (res.sts_code === ResponseCode.SUCCESS) {
            const resContent = res.content
            const cusNotes = {notes: resContent.notes, summaries: resContent.summaries};
            setCustomNote(cusNotes)
        } else {
            alertMessage(res.sts_code)
            setCustomNote(InitCustomNotes)
        }
    };

    const updateCustomNotes = async () => {
        setIsLoading(true)
        const res = await CandidateService.updateCustomNoteDetail({
            candidate_id: candidateId,
            notes: customNote.notes,
        })

        if (res.sts_code === ResponseCode.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
            setEdit(false)
        } else {
            toast.error(`Cập nhật thông tin thất bại`);
        }
    };

    const updateCddSummaries = async () => {
        setIsLoading(true)
        const res = await CandidateService.requestUpdateCddSummaries({
            candidate_id: candidateId,
            summaries: customNote.summaries,
        })

        if (res.sts_code === ResponseCode.SUCCESS) {
            showSuccessMessageSaveData(res.sts_code)
            setEdit(false)
        } else {
            toast.error(`Cập nhật thông tin thất bại`);
        }
    };

    useEffect(() => {
        console.log("fetchCandidateGeneral")
        if (candidateId) {
            fetchCustomNotes(candidateId)
        }
    }, [])

    const onChangeNoteInput = (event, fieldName) => {
        customNote.notes[event.target.name] = event.target.value
        setCustomNote({...customNote})
    }

    const onChangeSummaryInput = (event, index) => {
        customNote.summaries[index][event.target.name] = event.target.value
        setCustomNote({...customNote})
    }

    const onAddCddSummary = (event) => {
        console.log('onAddCareerSummary');

        if (customNote.summaries.length > 0) {
            let latestRow = customNote.summaries[customNote.summaries.length-1]
            let rowIsBlank = true
            Object.keys(latestRow).forEach(key => {
                if (latestRow[key]) {
                    rowIsBlank = false
                }
            })

            if (rowIsBlank) {
                alert("Tồn tại record cdd summary chưa được nhập thông tin.")
                return;
            }
        }

        customNote.summaries.push({id: ''});
        setCustomNote({...customNote})
    };

    const onShowMore = (item, index, selectField) => {
        item.index = index
        item.selectField = selectField
        setSelectedRecord({...item})
        setShowInputMoreModal(true)
    };

    const onSaveMore = (inputValue) => {
        setShowInputMoreModal(false)
        const pNotes = customNote.summaries.map(item => {
            if (item.index === selectedRecord.index) {
                item[selectedRecord.selectField] = inputValue
            }
            return item
        })
        setCustomNote({...customNote})
    };

    return (
        <>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Notes</h3>
                    <div className='card-tools'>
                        {isEdit &&
                            <>
                                <button type='button'
                                        className='btn btn-default mr-2'
                                        onClick={() => {
                                            setEdit(false);
                                        }}
                                >
                                    Cancel
                                </button>
                                <button type='button'
                                        className='btn btn-primary'
                                        onClick={() => updateCustomNotes()}
                                >
                                    Save
                                </button>
                            </>
                        }
                        {!isEdit &&
                            <button type='button'
                                    className='btn btn-default'
                                    onClick={() => {
                                        setEdit(true);
                                    }}
                            >
                                Edit
                            </button>
                        }
                    </div>
                </div>
                <div className='card-body'>
                    <div className='input-group'>
                        <label className={'w-100'}>Lưu ý quan trọng khi tương tác</label>
                        <textarea className='form-control'
                                  disabled={!isEdit}
                                  value={customNote.notes.important_note ? customNote.notes.important_note : ''}
                                  name={'important_note'}
                                  onChange={event => onChangeNoteInput(event)}/>
                        <AllUserInputField arrInfo={allInputInfo.allCandidateNotesInfo}
                                           field='important_note'/>
                    </div>
                    <div className='input-group mt-3'>
                        <label className={'w-100'}>General Note</label>
                        <textarea className='form-control'
                                  disabled={!isEdit}
                                  value={customNote.notes.general_note ? customNote.notes.general_note : ''}
                                  name={'general_note'}
                                  onChange={event => onChangeNoteInput(event)}/>
                        <AllUserInputField arrInfo={allInputInfo.allCandidateNotesInfo}
                                           field='general_note'/>
                    </div>
                    {userLoginInfo.is_superuser &&
                        <div className='input-group'>
                            <label className={'w-100'}>Brief DVTJCUV</label>
                            <input className='form-control'
                                   type={'text'}
                                   disabled={!isEdit}
                                   value={customNote.notes.brief_dvtjcuv || ''}
                                   name={'brief_dvtjcuv'}
                                   onChange={event => onChangeNoteInput(event)}/>
                        </div>
                    }
                </div>
            </div>
            <div className='card card-default'>
                <div className='card-header'>
                    <h3 className='card-title text-bold'>Cdd Summary</h3>
                    <div className='card-tools'>
                        <>
                            <button type='button'
                                    className='btn btn-default mr-2'
                                    onClick={() => onAddCddSummary()}
                            >
                                Add
                            </button>
                            <button type='button'
                                    className='btn btn-primary'
                                    onClick={() => updateCddSummaries()}
                            >
                                Save
                            </button>
                        </>
                    </div>
                </div>
                <div className='card-body table-responsive'>
                    <table
                        className='table table-hover table-bordered text-nowrap'
                        style={{
                            maxHeight: '80vh',
                            overflow: 'scroll',
                        }}
                    >
                        <thead>
                            <tr>
                                <th>Note time</th>
                                <th>Content</th>
                                <th>Note</th>
                            </tr>
                        </thead>

                        <tbody>
                        {customNote.summaries.map((item, index) => (
                            <tr key={`CandidateCustomNotes_${index}`}>
                                <td>
                                    {item.note_time || ''}
                                </td>
                                <td>
                                    <input className='form-control'
                                           type={'textarea'}
                                           value={item.content || ''}
                                           name={'content'}
                                           onChange={event => onChangeSummaryInput(event, index, "content")}/>
                                    <span className={'input-group-append'}>
                                        <button type='button' className='btn btn-sm btn-warning btn-flat btn-sm'
                                                onClick={() => onShowMore(item, index, "content")}>
                                            More
                                        </button>
                                    </span>
                                </td>
                                <td>
                                    <input className='form-control'
                                           type={'textarea'}
                                           value={item.note || ''}
                                           name={'note'}
                                           onChange={event => onChangeSummaryInput(event, index, "note")}/>
                                    <span className={'input-group-append'}>
                                        <button type='button' className='btn btn-sm btn-warning btn-flat btn-sm'
                                                onClick={() => onShowMore(item, index, "note")}>
                                            More
                                        </button>
                                    </span>
                                </td>
                            </tr>
                        ))
                        }
                        </tbody>
                    </table>
                </div>
            </div>

            {showInputMoreModal &&
            <InputMoreModal isShow={showInputMoreModal}
                            onClose={() => setShowInputMoreModal(false)}
                            onSave={(input) => onSaveMore(input)}
                            fieldTitle={"Input more"}
                            inputValue={selectedRecord[selectedRecord.selectField]}/>
            }
        </>
    )
}


export default CandidateCustomNotes;
